<template>
  <div>
    <div class="d-flex justify-content-center" v-if="carregando">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </div>

    <b-form ref="frmConfiguracao" v-if="!carregando" class="config-form">
      <b-form-group>
        <label>Cliente<span class="text-danger">*</span>:</label>
        <div class="input-group">
          <pv-dropdown
            class="form-control"
            optionLabel="text"
            emptyFilterMessage="Nenhum resultado"
            :filter="true"
            :options="sltCliente"
            v-model="defaultsSelect.cliente"
            @input="obterCliente"
            appendTo="mdlConfiguracaoId"
          ></pv-dropdown>

          <div class="input-group-append">
            <button
              class="btn btn-icon config-btn-add"
              type="button"
              @click="abrirMdlCadastrarCliente"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </b-form-group>

      <div class="row">
        <div class="col-8">
          <b-form-group>
            <label>Nome do cliente<span class="text-danger">*</span>:</label>
            <b-form-input
              name="nome"
              v-model="frmConfiguracao.nome"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-4">
          <b-form-group>
            <label>CPF/CNPJ:</label>
            <b-form-input
              name="cpfCnpj"
              v-model="cpfCnpjExibicao"
              maxlength="18"
            ></b-form-input>
            <small class="form-text text-muted config-helper-text">
              Exibido com máscara. Armazenado sem pontuação.
            </small>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-5">
          <b-form-group>
            <label>Tipo de negócio<span class="text-danger">*</span>:</label>
            <b-form-select
              :options="sltTipoNegocio"
              v-model="frmConfiguracao.tipoNegocio"
            ></b-form-select>
          </b-form-group>
        </div>

        <div class="col-3">
          <b-form-group>
            <label>CEP</label>
            <b-form-input
              name="cep"
              v-model="frmConfiguracao.cep"
              data-inputmask="'mask': '99999-999'"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-4">
          <b-form-group>
            <label>Fuso Horário<span class="text-danger">*</span>:</label>
            <b-form-select
              :options="sltFusoHorario"
              v-model="frmConfiguracao.fusoHorario"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
    </b-form>

    <modal-cadastrar-cliente
      ref="mdlCadastrarCliente"
      :sltTipoNegocio="sltTipoNegocio"
      @cliente:cadastrado="clienteCadastrado"
    ></modal-cadastrar-cliente>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import Utils from "@/core/utils/Utils";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

import Inputmask from "inputmask";
import { mapGetters } from "vuex";
import ModalCadastrarCliente from "./ModalCadastrarCliente.vue";

export default {
  props: {
    conta: Object
  },

  components: {
    "modal-cadastrar-cliente": ModalCadastrarCliente
  },

  data() {
    return {
      frmConfiguracao: {
        idConta: null,
        idCliente: "",
        nome: "",
        cep: "",
        cpfCnpj: "",
        tipoNegocio: null,
        fusoHorario: ""
      },
      carregando: true,
      sltTipoNegocio: [],
      sltFusoHorario: [
        {
          text: "UTC -5",
          value: "-5:00"
        },
        {
          text: "UTC -4",
          value: "-4:00"
        },
        {
          text: "UTC -3",
          value: "-3:00"
        },
        {
          text: "UTC -2",
          value: "-2:00"
        }
      ],
      defaultsSelect: {
        cliente: {
          text: "Selecione",
          value: null
        }
      }
    };
  },

  mounted() {
    this.abrir();
  },

  computed: {
    ...mapGetters(["validatorErrors"]),

    cpfCnpjExibicao: {
      get() {
        return Utils.formatarDocumento(this.frmConfiguracao.cpfCnpj);
      },
      set(valor) {
        this.frmConfiguracao.cpfCnpj = Utils.limparDocumento(valor);
      }
    }
  },

  methods: {
    // Calcula um dígito verificador de CPF/CNPJ pelo módulo 11, tratando cada
    // caractere (dígito ou letra do CNPJ alfanumérico) pelo seu valor ASCII - 48,
    // conforme especificação da Receita Federal para o novo CNPJ alfanumérico.
    calcularDigitoVerificador(base, pesos) {
      const soma = base
        .split("")
        .reduce(
          (acc, caractere, indice) =>
            acc + (caractere.charCodeAt(0) - 48) * pesos[indice],
          0
        );

      const resto = soma % 11;

      return resto < 2 ? 0 : 11 - resto;
    },

    validarCpf(cpf) {
      if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) {
        return false;
      }

      const pesos1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
      const pesos2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

      const digito1 = this.calcularDigitoVerificador(cpf.slice(0, 9), pesos1);
      const digito2 = this.calcularDigitoVerificador(
        cpf.slice(0, 9) + digito1,
        pesos2
      );

      return cpf.slice(9) === `${digito1}${digito2}`;
    },

    // Válido tanto para o CNPJ numérico atual quanto para o novo formato
    // alfanumérico (raiz e ordem podem ter letras; os dígitos verificadores
    // continuam sempre numéricos).
    validarCnpj(cnpj) {
      if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj) || /^(\w)\1{13}$/.test(cnpj)) {
        return false;
      }

      const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

      const digito1 = this.calcularDigitoVerificador(cnpj.slice(0, 12), pesos1);
      const digito2 = this.calcularDigitoVerificador(
        cnpj.slice(0, 12) + digito1,
        pesos2
      );

      return cnpj.slice(12) === `${digito1}${digito2}`;
    },

    validarDocumento(valor) {
      const documento = Utils.limparDocumento(valor);

      if (!documento) {
        return true;
      }

      if (documento.length === 11) {
        return this.validarCpf(documento);
      }

      if (documento.length === 14) {
        return this.validarCnpj(documento);
      }

      return false;
    },

    abrir() {
      const self = this;

      ApiService.post("conta/obter-configuracao", {
        idConta: this.conta.id
      })
        .then(async (response) => {
          const cliente = response.data.data.cliente;
          this.sltTipoNegocio = response.data.data.sltTipoNegocio;
          this.sltCliente = response.data.data.sltCliente;

          this.frmConfiguracao.idConta = this.conta.id;
          this.frmConfiguracao.idCliente = cliente.id;
          this.frmConfiguracao.nome = cliente.nome;
          this.frmConfiguracao.cep = cliente.cep;
          this.frmConfiguracao.cpfCnpj = Utils.limparDocumento(
            cliente.documento
          );
          this.frmConfiguracao.tipoNegocio = cliente.tipo;
          this.frmConfiguracao.fusoHorario = cliente.fusoHorario;

          this.selecionarCliente(this.frmConfiguracao.idCliente);

          this.carregando = false;

          await this.$nextTick();

          const frmConfiguracao = this.$refs["frmConfiguracao"];
          Inputmask().mask(frmConfiguracao.querySelectorAll("input"));
        })
        .then(function () {
          self.validacao();

          self.$watch(
            "frmConfiguracao",
            function () {
              self.$emit("aba-alterada", true);
            },
            { deep: true }
          );
        });
    },

    validacao() {
      const frmConfiguracao = this.$refs["frmConfiguracao"];
      const self = this;

      this.fv = formValidation(frmConfiguracao, {
        fields: {
          idCliente: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          },
          nome: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          },
          tipoNegocio: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          },
          cpfCnpj: {
            validators: {
              callback: {
                message: "CPF/CNPJ inválido.",
                callback: (input) => this.validarDocumento(input.value)
              },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      });
    },

    salvar() {
      return this.fv.validate().then((status) => {
        if (status == "Valid") {
          ApiService.post("conta/atualizar-configuracao", this.frmConfiguracao)
            .then((res) => {
              this.conta.nome = this.frmConfiguracao.nome;
              this.sltCliente = res.data.data.sltCliente;

              this.selecionarCliente(this.frmConfiguracao.idCliente);

              this.$emit("aba-alterada", false);

              Swal.fire({
                title: "MENSAGEM",
                text: "Atualizado com sucesso!",
                icon: "success",
                heightAuto: false
              });
            })
            .catch(() => {
              for (const error in this.validatorErrors) {
                this.fv
                  .updateValidatorOption(
                    error,
                    "blank",
                    "message",
                    this.validatorErrors[error]
                  )
                  .updateFieldStatus(error, "Invalid", "blank");
              }
            });
        }
      });
    },

    abrirMdlCadastrarCliente() {
      this.$refs["mdlCadastrarCliente"].abrir();
    },

    clienteCadastrado({ cliente, sltCliente }) {
      this.frmConfiguracao.idCliente = cliente.cliente_id;
      this.frmConfiguracao.nome = cliente.cli_nome;
      this.frmConfiguracao.cep = cliente.cli_cep;
      this.frmConfiguracao.cpfCnpj = Utils.limparDocumento(
        cliente.cli_documento
      );
      this.frmConfiguracao.tipoNegocio = cliente.tipo_negocio_id;

      this.sltCliente = sltCliente;

      this.selecionarCliente(cliente.cliente_id);
    },
    obterCliente(cliente) {
      this.frmConfiguracao.idCliente = cliente?.id;
      this.frmConfiguracao.nome = cliente?.nome;
      this.frmConfiguracao.cep = cliente?.cep;
      this.frmConfiguracao.cpfCnpj = Utils.limparDocumento(cliente?.documento);
      this.frmConfiguracao.tipoNegocio = cliente?.tipo;
    },

    selecionarCliente(value) {
      this.sltCliente.every((obj) => {
        if (obj.value == value) {
          this.defaultsSelect.cliente = { ...obj };
        }

        return true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.config-form {
  ::v-deep label {
    font-weight: 500;
    color: #464457;
    margin-bottom: 0.4rem;
  }

  ::v-deep .form-control,
  ::v-deep .custom-select {
    height: calc(1.5em + 1.3rem + 2px);
    padding: 0.65rem 1rem;
    border-radius: 8px;
    border: 1px solid #e2e0ea;

    &:focus {
      border-color: #472282;
      box-shadow: 0 0 0 0.1rem rgba(71, 34, 130, 0.15);
    }
  }
}

.config-helper-text {
  font-size: 0.72rem;
  color: #9795a6;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.config-btn-add {
  background-color: #472282;
  border-color: #472282;
  color: #fff;
  border-radius: 0 8px 8px 0;

  &:hover,
  &:focus {
    background-color: #3a1b6b;
    border-color: #3a1b6b;
    color: #fff;
  }
}
</style>
